import React from 'react';
import { LanguageContext } from './languageContext';

function withLanguage(WrappedComponent) {
    return props => (
        <LanguageContext.Consumer>
            {lang => (
                <WrappedComponent
                    {...props}
                    lang={lang}
                />
            )}
        </LanguageContext.Consumer>
    );
}

export default withLanguage;



// WEBPACK FOOTER //
// ./src/translations/withLanguage.js